import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import CardIcon from './svg/CardIcon';
import SpendingMonitorIcon from './svg/SpendingMonitorIcon';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import triStateBooleanShape from 'react/signups/card/shapes/TriStateBoolean';

const useStyles = makeStyles({
  icon: {
    marginTop: '3px',
  },
});

export default function AtmAccessInfo({ atmAccess }) {
  const classes = useStyles();

  const ccYesText =
    'We will send you a card with access to 55,000+ ATMs with no fees for cash withdrawals.';
  const slidersNoText =
    'You will be able to block access to cash using our Spending Settings once you order the card.';
  const slidersYesText =
    'You can still choose to block cash access at any time by updating the Spending Settings rules.';

  return (
    <div>
      {atmAccess === 'no' && (
        <>
          <Grid container spacing={1} wrap="nowrap">
            <Grid classes={{ root: classes.icon }} item>
              <SpendingMonitorIcon />
            </Grid>
            <Grid item>
              <CardText>{slidersNoText}</CardText>
            </Grid>
          </Grid>
        </>
      )}
      {atmAccess === 'yes' && (
        <>
          <Grid container spacing={1} wrap="nowrap">
            <Grid classes={{ root: classes.icon }} item>
              <CardIcon />
            </Grid>
            <Grid item>
              <CardText>{ccYesText}</CardText>
            </Grid>
          </Grid>
          <Grid container spacing={1} wrap="nowrap">
            <Grid classes={{ root: classes.icon }} item>
              <SpendingMonitorIcon />
            </Grid>
            <Grid item>
              <CardText>{slidersYesText}</CardText>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

AtmAccessInfo.propTypes = {
  atmAccess: triStateBooleanShape.isRequired,
};
